// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1zCU6","notes":"Notes_notes__2Iz39","note":"Notes_note__5qfum","markdown":"Notes_markdown__2AkhF"};